export default __webpack_public_path__ + "static/petiteMaro3.inspirations-b67f12e97f6511a01a58dc48a128c2e6.jpg";